import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

import './style-confirm-dialog.scss';

export function StyleConfirmDialog({ style, onConfirm, onCancel }) {
  if (!style) {
    return null;
  }

  return (
    <div className="style-confirm-dialog text-center text-gray-darker">
      <div className="heading-4 mb-2">Change to the following style?</div>
      <div className="px-2">
        <div className="mb-0_25 heading-4">{style.styleName}</div>
        <div className="mb-1">{style.baseMSRP ? formatPriceString(style.baseMSRP) : 'N/A'}</div>
        <div className="d-flex flex-column align-items-center">
          <Button
            color="primary-b"
            onClick={onConfirm}
            className="size-16 text-transform-none py-0_5 mb-0_5"
            data-tracking-id="comparator_change_style"
          >
            Yes, Change Style
          </Button>
          <Button color="link" size="sm" className="p-0 text-gray-darker text-transform-none" onClick={onCancel}>
            Back to Styles
          </Button>
        </div>
      </div>
    </div>
  );
}

StyleConfirmDialog.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  style: PropTypes.shape({
    styleName: PropTypes.string,
    baseMSRP: PropTypes.number,
  }),
};

StyleConfirmDialog.defaultProps = {
  style: null,
};
